module.exports = __webpack_public_path__ + "img/big.8c87e051.jpg";